// client/src/config/legal.js
// ============================================
// LEGAL CONFIGURATION
// Bump CURRENT_TERMS_VERSION whenever Terms of Service
// or Privacy Policy change, to force re-acceptance.
// ============================================

export const CURRENT_TERMS_VERSION = '2026-04-v1';

export const TERMS_URL = '/terms';
export const PRIVACY_URL = '/privacy';
